export enum GA_EVENTS {
  VIEW_PAGE = 'view_page',
  VIEW_ITEM = 'view_item',
  VIEW_PROMO = 'view_promotion',
  ERROR_PAGE = 'error_page',
  CLICK_PROCEED = 'click_proceed',
  CLICK_WHATSAPP = 'click_whatsapp',
  CLICK_CALLUS = 'click_callus',
  VIEW_INSTALLMENT = 'view_installment',
  COMPLETE_PURCHASE = 'complete_purchase',
  PURCHASE = 'purchase',
  RATE_US = 'rate_us',
  TO_PLAYMARKET = 'to_playmarket',
  TO_APPSTORE = 'to_appstore',
  INFO_PAGE = 'info_page',
  CONTACT_US = 'contact_us',
  CLICK_BTN = 'click_btn',
  VIEW_QUOTE = 'view_quote',
  CLICK_LINK = 'click_link',
  EXPAND_ON = 'expand_on',
  SWITCH_ADDON = 'switch_addon',
  SELECT_ITEM = 'select_item',
  PAYMENT_TYPE = 'payment_type',
  START_PURCHASE = 'start_purchase',
  VIEW_POPUP = 'view_popup',
  CLICK_PAYMENT_POLICY = 'click_download_policy',
  CLICK_PAYMENT_RECEIPT = 'click_payment_receipt',
  TRY_AGAIN = 'try_again',
  TYPE_PHONE = 'type_phone',
  TYPE_VIN = 'type_vin',
  CHOOSE_MAKE = 'chooseMake',
  CHOOSE_MODEL = 'chooseModel',
  CHOOSE_YEAR = 'chooseYear',
  CHOOSE_SEATS = 'chooseSeats',
  CHOOSE_CYLINDERS = 'chooseCylinders',
  INPUT_ERROR = 'input_error',
  NETWORK_ERROR = 'network_error',
  FORM_SUBMIT = 'form_submit',
  VIN_COMPLETED = 'chassis_completed',
  VIN_UNRECOGNIZED = 'vin_unrecognized',
  CAR_DETAILS_COMPLETED = 'car_details_completed',
  POPUP_CROSS_CLOSE = 'popup_cross_close',
  CLICK_POLICY_WORDINGS = 'click_policy_wordings',
  CLICK_BANNER = 'click_banner',
  DOWNLOAD_APP = 'donwload_app',
  CLICK_ICON = 'click_icon',
  CLICK_LEARN_MORE = 'click_learn_more',
  CLICK_HINT = 'click_hint',
  EDIT_FIELD = 'edit_field',
  EDIT_CAR_DETAILS = 'edit_car_details',
  CLICK_TAB = 'click_tab',
}

export const PRODUCT = 'carIns';
export const PRODUCT_CATEGORY = 'OCR';
export const CAR_OCR_QUOTE_INFO = 'carOcrQuoteInfo';
export const PAYMENT_METHOD = 'paymentMethod';
export const COOKIE_TIMESTAMP_NAME = 'ga_session_timestamp';

// TODO: should be in app
export enum PAGE_NAMES {
  PHONE = 'mobile_number',
  CHASSIS_NUMBER = 'chassis_number',
  CHASSIS_NUMBER_CAR_DETAILS = 'chassis_number_car_details',
  CAR_DETAILS = 'edit_car_details',
  MORE_DETAILS = 'give_us_more_details',
  PLANS = 'select_plan',
  SELECT_DEDUCTIBLE = 'customize_policy',
  PLATE_NUMBER = 'plate_number',
  INSURED_INFO = 'personal_information',
  QUOTE = 'your_quote',
  INSURANCE_RESULT = 'your_policy',
  SUCCESS_PAGE = 'success_page',
  SWITCH_TO_RENEW = 'switch_to_renew',
  PLATE_QID = 'plate_qid',
  ADDITIONAL_INFORMATION = 'additional_information',
}

export const customerTypeMap = ['private', 'company'];
